import _ from 'underscore';

import { Charting }             from '../../../types/charting';
import { useChartReportExport } from './useChartReportExport';

type ReportChartingType = Charting.Reports.BudgetCostTypesByProject.ChartingType;
type ReportChartingData = Charting.Reports.BudgetCostTypesByProject.ChartingData;

type HookType = Charting.Reporting.ChartReportExportHookMethod<ReportChartingType, ReportChartingData>;
type HookOptions = Charting.Reporting.ChartReportExportHookOptions<ReportChartingType>;

export const useBudgetCostTypesByProjectChartReportExport: HookType = ( options: HookOptions ) => {
	
	const defaultHandlers = useChartReportExport( options );
	
	/* Generate text/ string */
	const generateReportText: ReturnType<HookType>['generateReportText'] = ( data ) => {
		
		let text = generateCSVData( data ).data.map( row => {
			
			const [ projectNamePair, ...valuePairs ] = _.pairs( row );
			
			return [
				
				projectNamePair[ 1 ],
				
				...valuePairs.map( ( [ label, value ] ) => `- ${ label }: ${ value }` )
			
			].join( '\n' );
		} );
		
		return text.join( '\n\n' );
	}
	
	/* Generate CSV Headers + Data */
	const generateCSVData: ReturnType<HookType>['generateCSVData'] = ( data ) => {
		
		// [ Project Name, Activity Cost, Hiring Cost, Custom Cost, Total ]
		let csvHeaders = [
			
			{ label: "Project", key: "Project Name" },
			
			...data.labels.map( ( label: string, index ) => ( {
				label: label,
				key:   label
			} ) )
		];
		
		let csvData = data.datasets.map( dataset => {
			
			const csvRow = {
				'Project Name': dataset.label,
			}
			
			dataset.data.map( ( datapointValue, index ) => {
				csvRow[ `${ data.labels[ index ] }` ] = options.datapointFormatter( datapointValue );
			} );
			
			return csvRow;
		} );
		
		return {
			headers:  csvHeaders,
			data:     csvData,
			filename: `Report - ${ options.title }.csv`,
			target:   '_blank',
		}
	}
	
	return {
		generateReportText,
		generateCSVData,
		handleCopiedtoClipboard: defaultHandlers.handleCopiedtoClipboard,
		handleCSVGenerated:      defaultHandlers.handleCSVGenerated,
		handleSaveAsImage:       defaultHandlers.handleSaveAsImage,
	};
};
